import React from 'react';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { isInternalURL } from '@plone/volto/helpers';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Segment, Card, Header, Grid, Label, Container } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { FormattedMessage, injectIntl } from 'react-intl';
import { UniversalLink, Image } from '@plone/volto/components';
import { getVocabulary } from '@plone/volto/actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { keys, isEmpty, map, filter } from 'lodash';
import { formatDate } from '../../../helpers'
import { Sharing } from '../../';
import defaultImage from '../../Footer/img/logo-proursa-blanc.svg';

const NewsListing = ({ items, linkTitle, linkHref, isEditMode, blockTitle }) => {
	const intl = useIntl();
	let href = (linkHref?.[0]?.['@id']) || '';
	let link = href ? flattenToAppURL(href) : '';

	const vocabularySubjects = 'plone.app.vocabularies.Keywords';
	const dispatch = useDispatch();
	const itemsSubjects = useSelector(
		(state) =>
			state.vocabularies[vocabularySubjects] && state.vocabularies[vocabularySubjects].items
				? [...state.vocabularies[vocabularySubjects].items]
				: [],
		shallowEqual,
	);

  	const formatDateWithLocale = (date) => {
    	return formatDate(date, intl.locale);
  	};

	useEffect(() => {
		dispatch(getVocabulary({ vocabNameOrURL: vocabularySubjects }));
	}, [dispatch]);

	const getNewsItemSubject = function (subject) {
		if (!itemsSubjects) {
			return subject
		}
		for (let item of itemsSubjects) {
			if (item.value === subject) return item.label
		}
		return subject
	}

	return (
		<>
			{blockTitle && <h3 className="directLinks__title my-0">{blockTitle}</h3>}
			<Grid>
				<Grid.Row  columns={12} className='pt-0'>
					{items.map((item, index) => (
						<Grid.Column className="mb-4 " 
							mobile={12}
							tablet={index === 0 ? 12 : 6}
							computer={index === 0 ? 12 : 4}
							widescreen={index === 0 ? 12 : 4} 
							key={item['@id']} >
							<Card fluid as="article" className={"newsItem position-relative " + (index === 0 ? 'newsItem--first' : 'newsItem--regular') + (item?.image_field ? ' newsItem-hasImage' : ' newsItem--noImage')}>
								<figure className='newsItem__figure position-relative m-0'>
									<div className='overflow-hidden  newsItem__figure__wrapper'>
										{item.image_field ? (
											<Image
												className="newsItem__img m-0 image"
												item={item}
												alt={item.image_caption ? item.image_caption : ''}
												sizes={(index === 0 ? '(max-width: 767px) 100vw, 50vw' : '(max-width: 767px) 100vw, (max-width: 991px) 50vw, 33.33vw')}
											/>
										) : (
											<img
												src={defaultImage} 
												className="w-100 h-auto"
												width="212" height="44"
												alt=""
												/>
										)}
									</div>
									<span className="newsItem__readmore" aria-hidden="true"><FontAwesomeIcon icon={faChevronRight} /></span>
								</figure>
								<Card.Content >									
									<Card.Header as="h3" className={"newsItem__title"  + (index === 0 ? ' me-5' : ' ' )}>
										<UniversalLink href={flattenToAppURL(item['@id'])} className="newsItem__link stretched-link">{item.title}</UniversalLink>
									</Card.Header>
									<Card.Description as="p" className="newsItem__desc">{item.description}</Card.Description>
								</Card.Content>
								<Card.Content extra className=" newsItem__meta">
									<time className="newsItem__date" dateTime={item.Date}>{formatDateWithLocale(item.effective)}</time>
									{item?.Subject?.length > 0 && (
										<ul className='newsItem__meta__list list-unstyled my-0'>
											{map(item.Subject.slice(0, 1), (item, index) => (
												<li key={item}>
													<span className="newsItem__subject">{getNewsItemSubject(item)}</span>
												</li>
											))}
										</ul>
									)}					
								</Card.Content>
								<Sharing id={item['@id']} title={item.title} url={flattenToAppURL(item['@id'])} />
							</Card>
						</Grid.Column>
					))}
				</Grid.Row>
			</Grid>

			{link &&
				<p className="readMoreItem d-print-none  mb-5 text-center pt-2">
					<UniversalLink href={link} className="readMoreItem__btn ui primary button ">
						
						{linkTitle ? (<span>{linkTitle}</span>) : (
							<>
								<FormattedMessage id="See more" defaultMessage="See more" /> {blockTitle}
							</>
						)} 
					</UniversalLink>
				</p>
			}
		</>
	);
}

NewsListing.propTypes = {
	linkHref: PropTypes.arrayOf(PropTypes.any),
	items: PropTypes.arrayOf(PropTypes.any).isRequired,
	linkMore: PropTypes.any,
	isEditMode: PropTypes.bool,
};

export default NewsListing;
